import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";

export default function Not_Return_PopUp({
  notReturn,
  setNotReturn,
  popUpData,
  trigger,
  setTrigger,
  setPopUp,
  routeType,
}) {
  console.log("not return popUp need to be shown here",popUpData)
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("nodeToken");
  const dispatch = useDispatch();
  console.log("data page load",popUpData)
  const onEreExtendAPI = async () => {
    setLoading(true);
    let reqObj;
    reqObj = {
      employee_id: popUpData?.candidate_id,
      project_id : popUpData?.project_unique_id,
      demobilization_date : popUpData?.demobilization_date
    };
    const routeSpecificFields =
      routeType === "Emergency_leave"
        ? { emergency_leave_status: "NOT RETURN FROM ERE" }
        : { annual_vacation_status: "NOT RETURN FROM ANNUAL VACATION" };
    const endPoint =
      routeType === "Emergency_leave"
        ? "/ere/erenotreturn"
        : routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/AnnualvacationNotReturn"
          : "";
    const reqObject = { ...reqObj, routeSpecificFields };
    try {
      const response = await nodeinstance.put(`${endPoint}`, reqObject, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setNotReturn(false);
        setPopUp(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log("error........", error);
      dispatch(
        setAppError({
          msg: "Failed while updating ERE-Status",
        })
      );
      setLoading(false);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          notReturn ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setNotReturn(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div>
            <h2>
              Are you sure, Do you want to make this employee as Not return from
              ERE ?{" "}
            </h2>
          </div>
          <div className="flex gap-3 w-full justify-center">
            <button
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              onClick={() => onEreExtendAPI()}
            >
              <p>Submit</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
